// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { EshopShoppingCartControllerAddElectronicWalletTransactionToShoppingCartData } from './EshopShoppingCartControllerAddElectronicWalletTransactionToShoppingCartData.gen';
import type { EshopShoppingCartControllerAddElectronicWalletTransactionToShoppingCartErrors } from './EshopShoppingCartControllerAddElectronicWalletTransactionToShoppingCartErrors.gen';
import type { EshopShoppingCartControllerAddElectronicWalletTransactionToShoppingCartResponses } from './EshopShoppingCartControllerAddElectronicWalletTransactionToShoppingCartResponses.gen';
import type { EshopShoppingCartControllerAddFeeToShoppingCartData } from './EshopShoppingCartControllerAddFeeToShoppingCartData.gen';
import type { EshopShoppingCartControllerAddFeeToShoppingCartErrors } from './EshopShoppingCartControllerAddFeeToShoppingCartErrors.gen';
import type { EshopShoppingCartControllerAddFeeToShoppingCartResponses } from './EshopShoppingCartControllerAddFeeToShoppingCartResponses.gen';
import type { EshopShoppingCartControllerAddOffenseToShoppingCartData } from './EshopShoppingCartControllerAddOffenseToShoppingCartData.gen';
import type { EshopShoppingCartControllerAddOffenseToShoppingCartErrors } from './EshopShoppingCartControllerAddOffenseToShoppingCartErrors.gen';
import type { EshopShoppingCartControllerAddOffenseToShoppingCartResponses } from './EshopShoppingCartControllerAddOffenseToShoppingCartResponses.gen';
import type { EshopShoppingCartControllerAddTicketFaresForCompanyCardsToShoppingCartData } from './EshopShoppingCartControllerAddTicketFaresForCompanyCardsToShoppingCartData.gen';
import type { EshopShoppingCartControllerAddTicketFaresForCompanyCardsToShoppingCartErrors } from './EshopShoppingCartControllerAddTicketFaresForCompanyCardsToShoppingCartErrors.gen';
import type { EshopShoppingCartControllerAddTicketFaresForCompanyCardsToShoppingCartResponses } from './EshopShoppingCartControllerAddTicketFaresForCompanyCardsToShoppingCartResponses.gen';
import type { EshopShoppingCartControllerAddTicketFareToShoppingCartData } from './EshopShoppingCartControllerAddTicketFareToShoppingCartData.gen';
import type { EshopShoppingCartControllerAddTicketFareToShoppingCartErrors } from './EshopShoppingCartControllerAddTicketFareToShoppingCartErrors.gen';
import type { EshopShoppingCartControllerAddTicketFareToShoppingCartResponses } from './EshopShoppingCartControllerAddTicketFareToShoppingCartResponses.gen';
import type { EshopShoppingCartControllerGetShoppingCartData } from './EshopShoppingCartControllerGetShoppingCartData.gen';
import type { EshopShoppingCartControllerGetShoppingCartErrors } from './EshopShoppingCartControllerGetShoppingCartErrors.gen';
import type { EshopShoppingCartControllerGetShoppingCartItemsCountData } from './EshopShoppingCartControllerGetShoppingCartItemsCountData.gen';
import type { EshopShoppingCartControllerGetShoppingCartItemsCountErrors } from './EshopShoppingCartControllerGetShoppingCartItemsCountErrors.gen';
import type { EshopShoppingCartControllerGetShoppingCartItemsCountResponses } from './EshopShoppingCartControllerGetShoppingCartItemsCountResponses.gen';
import type { EshopShoppingCartControllerGetShoppingCartResponses } from './EshopShoppingCartControllerGetShoppingCartResponses.gen';
import type { EshopShoppingCartControllerRemoveAllItemsFromShoppingCartData } from './EshopShoppingCartControllerRemoveAllItemsFromShoppingCartData.gen';
import type { EshopShoppingCartControllerRemoveAllItemsFromShoppingCartErrors } from './EshopShoppingCartControllerRemoveAllItemsFromShoppingCartErrors.gen';
import type { EshopShoppingCartControllerRemoveAllItemsFromShoppingCartResponses } from './EshopShoppingCartControllerRemoveAllItemsFromShoppingCartResponses.gen';
import type { EshopShoppingCartControllerRemoveItemFromShoppingCartData } from './EshopShoppingCartControllerRemoveItemFromShoppingCartData.gen';
import type { EshopShoppingCartControllerRemoveItemFromShoppingCartErrors } from './EshopShoppingCartControllerRemoveItemFromShoppingCartErrors.gen';
import type { EshopShoppingCartControllerRemoveItemFromShoppingCartResponses } from './EshopShoppingCartControllerRemoveItemFromShoppingCartResponses.gen';
import type { Options } from './Options.gen';

export class EshopShoppingCartController {
    /**
     * Get shopping cart based on logged account.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.
     */
    public static getShoppingCart<ThrowOnError extends boolean = false>(options?: Options<EshopShoppingCartControllerGetShoppingCartData, ThrowOnError>) {
        return (options?.client ?? client).get<EshopShoppingCartControllerGetShoppingCartResponses, EshopShoppingCartControllerGetShoppingCartErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/shopping-cart',
            ...options
        });
    }
    
    /**
     * Get shopping cart items count based on logged account.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.
     */
    public static getShoppingCartItemsCount<ThrowOnError extends boolean = false>(options?: Options<EshopShoppingCartControllerGetShoppingCartItemsCountData, ThrowOnError>) {
        return (options?.client ?? client).get<EshopShoppingCartControllerGetShoppingCartItemsCountResponses, EshopShoppingCartControllerGetShoppingCartItemsCountErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/shopping-cart/items/count',
            ...options
        });
    }
    
    /**
     * Add a fee to shopping cart.
     *
     * Only available fee in eshop is fee for card application<br>
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **INVALID_FEE** - Fee does not exist, is disabled or cannot be disabled.<br>
     * + **INVALID_CARD_APPLICATION** - Card application is invalid or does not exist.<br>
     * + **CARD_APPLICATION_ALREADY_HAS_ORDER** - Card application already has order.
     */
    public static addFeeToShoppingCart<ThrowOnError extends boolean = false>(options: Options<EshopShoppingCartControllerAddFeeToShoppingCartData, ThrowOnError>) {
        return (options.client ?? client).post<EshopShoppingCartControllerAddFeeToShoppingCartResponses, EshopShoppingCartControllerAddFeeToShoppingCartErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/shopping-cart-items/fee',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Add an electronic wallet transaction to shopping cart.
     *
     * Operation `RECHARGE` is not permitted when card is invalid.<br>
     * Only available operation Type is RECHARGE.<br>
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **INVALID_BUS_STOP_COMBINATION** - Invalid bus stop combination.<br>
     * + **INVALID_BUS_STOP_ZONE_COMBINATION** - Invalid bus stop zone combination.<br>
     * + **INVALID_ELECTRONIC_WALLET** - Electronic wallet does not exist.<br>
     * + **INVALID_ELECTRONIC_WALLET_OPERATION** - Electronic wallet operation does not exist or is not allowed.<br>
     * + **INVALID_E_WALLET_MIN_MAX_RECHARGE_VALUE** - Invalid min or max e-wallet recharge value.<br>
     * + **INVALID_E_WALLET_MAX_AMOUNT** - Invalid e-wallet max amount.<br>
     * + **INVALID_CUSTOMER_CARD** - Customer card does not exist or has invalid card state.<br>
     * + **VIRTUAL_CARD_EWALLET_NOT_ALLOWED** - Virtual card e-wallet is not allowed in system configuration.<br>
     * + **SMART_CARD_WITHOUT_STRUCTURE_EWALLET_NOT_ALLOWED** - Smart card without structure e-wallet is not allowed.
     */
    public static addElectronicWalletTransactionToShoppingCart<ThrowOnError extends boolean = false>(options: Options<EshopShoppingCartControllerAddElectronicWalletTransactionToShoppingCartData, ThrowOnError>) {
        return (options.client ?? client).post<EshopShoppingCartControllerAddElectronicWalletTransactionToShoppingCartResponses, EshopShoppingCartControllerAddElectronicWalletTransactionToShoppingCartErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/shopping-cart-items/e-wallet-transaction',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Add a ticket fare to shopping cart.
     *
     * Business error `InvalidDate` is returned when property `validFrom` is in past.<br>
     * Business error `TicketFareValidToMoreThanCardValidTo` is carrying card and ticket validTo in payload.<br>
     * Business error `TicketFareValidToMoreThanProfileValidTo` is carrying profile and ticket validTo in payload.<br>
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **INVALID_CUSTOMER_CARD** - Customer card does not exist or has invalid card state.<br>
     * + **INVALID_ZONE** - Zone does not exist or is missing in the given ticket combination.<br>
     * + **INVALID_TICKET_COMBINATION** - Ticket combination does not exist, is expired or isn´t enable for sell.<br>
     * + **INVALID_DATE** - Date is invalid. See extra information in swagger documentation.<br>
     * + **TICKET_FARE_VALID_TO_MORE_THAN_CARD_VALID_TO** - Ticket fare validTo is more than customer card validTo.<br>
     * + **TICKET_FARE_VALIDITY_NOT_IN_PROFILE_VALIDITY** - Ticket fare validity is not within customer profile validity.<br>
     * + **INVALID_CUSTOMER_PROFILE_TYPE** - Customer profile type does not exist or for the given ticket combination does not match with card.<br>
     * + **INVALID_PRICE_LIST_ZONE** - Price list zone does not exist.<br>
     * + **INVALID_TICKET_FARE_VALID_FROM** - Ticket valid from must be in interval defined by global setting.<br>
     * + **TICKET_ALREADY_IN_CART_FOR_CARD** - Ticket already in shopping cart for card.<br>
     * + **INVALID_TARIFF** - Invalid tariff.<br>
     * + **PURCHASE_TICKET_FARE_FOR_ANONYMOUS_QR_CARD_NOT_ALLOWED** - Purchase ticket fare for anonymous QR card is not allowed.<br>
     * + **ISIC_INVALID_GRACE_PERIOD** - The ISIC/student status was found invalid. The customer cannot buy coupons for this profile until the status is renewed.<br>
     * + **ISIC_CARD_NUMBER_NOT_VALID** - Isic card number is not valid for customer and discount.
     */
    public static addTicketFareToShoppingCart<ThrowOnError extends boolean = false>(options: Options<EshopShoppingCartControllerAddTicketFareToShoppingCartData, ThrowOnError>) {
        return (options.client ?? client).post<EshopShoppingCartControllerAddTicketFareToShoppingCartResponses, EshopShoppingCartControllerAddTicketFareToShoppingCartErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/shopping-cart-items/ticket-fare',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Add a ticket fares for company cards to shopping cart.
     *
     * Business error `InvalidDate` is returned when property `validFrom` is in past.<br>
     * Business error `TicketFareValidToMoreThanCardValidTo` is carrying card and ticket validTo in payload.<br>
     * Business error `TicketFareValidToMoreThanProfileValidTo` is carrying profile and ticket validTo in payload.<br>
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **INVALID_CUSTOMER_CARD** - Customer card does not exist or has invalid card state.<br>
     * + **INVALID_ZONE** - Zone does not exist or is missing in the given ticket combination.<br>
     * + **INVALID_TICKET_COMBINATION** - Ticket combination does not exist, is expired or isn´t enable for sell.<br>
     * + **INVALID_DATE** - Date is invalid. See extra information in swagger documentation.<br>
     * + **TICKET_FARE_VALID_TO_MORE_THAN_CARD_VALID_TO** - Ticket fare validTo is more than customer card validTo.<br>
     * + **TICKET_FARE_VALIDITY_NOT_IN_PROFILE_VALIDITY** - Ticket fare validity is not within customer profile validity.<br>
     * + **INVALID_CUSTOMER_PROFILE_TYPE** - Customer profile type does not exist or for the given ticket combination does not match with card.<br>
     * + **INVALID_PRICE_LIST_ZONE** - Price list zone does not exist.<br>
     * + **INVALID_TICKET_FARE_VALID_FROM** - Ticket valid from must be in interval defined by global setting.<br>
     * + **TICKET_ALREADY_IN_CART_FOR_CARD** - Ticket already in shopping cart for card.<br>
     * + **INVALID_TARIFF** - Invalid tariff.
     */
    public static addTicketFaresForCompanyCardsToShoppingCart<ThrowOnError extends boolean = false>(options: Options<EshopShoppingCartControllerAddTicketFaresForCompanyCardsToShoppingCartData, ThrowOnError>) {
        return (options.client ?? client).post<EshopShoppingCartControllerAddTicketFaresForCompanyCardsToShoppingCartResponses, EshopShoppingCartControllerAddTicketFaresForCompanyCardsToShoppingCartErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/shopping-cart-items/company-ticket-fares',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Add an offense to shopping cart from eshop.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.
     */
    public static addOffenseToShoppingCart<ThrowOnError extends boolean = false>(options: Options<EshopShoppingCartControllerAddOffenseToShoppingCartData, ThrowOnError>) {
        return (options.client ?? client).post<EshopShoppingCartControllerAddOffenseToShoppingCartResponses, EshopShoppingCartControllerAddOffenseToShoppingCartErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/shopping-cart-items/offense',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Remove all items from shopping cart.
     */
    public static removeAllItemsFromShoppingCart<ThrowOnError extends boolean = false>(options?: Options<EshopShoppingCartControllerRemoveAllItemsFromShoppingCartData, ThrowOnError>) {
        return (options?.client ?? client).delete<EshopShoppingCartControllerRemoveAllItemsFromShoppingCartResponses, EshopShoppingCartControllerRemoveAllItemsFromShoppingCartErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/shopping-cart-items',
            ...options
        });
    }
    
    /**
     * Remove item from shopping cart.
     */
    public static removeItemFromShoppingCart<ThrowOnError extends boolean = false>(options: Options<EshopShoppingCartControllerRemoveItemFromShoppingCartData, ThrowOnError>) {
        return (options.client ?? client).delete<EshopShoppingCartControllerRemoveItemFromShoppingCartResponses, EshopShoppingCartControllerRemoveItemFromShoppingCartErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/shopping-cart-items/{id}',
            ...options
        });
    }
}
